<template>
  <div>
    <PageProgress v-if="progress"/>
    <div v-if="!progress" class="inner">
      <div class="header mb-4">
        <h1>Cache Management</h1>
      </div>
      <v-btn size="x-large" variant="flat" color="primary" @click="flush">Flush All</v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import PageProgress from '@/components/PageProgress.vue';
import { cacheService } from '@/services/api';

export default {
  name: 'CacheManagement',
  components: { PageProgress },
  data: () => ({
    progress: false,
  }),
  methods: {
    async flush() {
      this.progress = true;
      await new Promise(resolve => setTimeout(resolve, 1500));
      return cacheService.flush().then(() => this.progress = false);
    },
  }
};
</script>

<style scoped>
</style>
